// Add global to window, assigning the value of window itself.
// This is a workaround for dependencies that expect `global` to be defined
// https://github.com/angular/angular-cli/issues/8160#issuecomment-386153833
(window as any).global = window;
